/* eslint-disable react/prop-types */
import { strCode } from "../../../consts";

import { GradientLoader, TextOverflowWrapper } from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";

export const RolesTabTableColumns = [
  {
    Header: strCode.ROLES_NAME_TITLE,
    accessor: "group",
    Cell: ({ cell, isLoading, cellWidth5 }) => {
      return (
        <CellWrapper width="100%" minWidth="150px">
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={cellWidth5} height={24} animationDuration={32} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.FEATURES_TITLE,
    accessor: "features",
    Cell: ({ cell, isLoading, cellWidth3 }) => {
      return (
        <CellWrapper width="100%">
          <TextOverflowWrapper style={{ textWrap: "wrap" }}>
            {isLoading ? (
              <GradientLoader width={cellWidth3} height={24} animationDuration={32} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  }
];
